import { Dayjs } from "dayjs";
import HttpClient from "../../../../core/HttpClient";
import { Authentication } from "@leedpulse-monorepo/classes";
import type { LastSmsEntry } from "./getOverviewStats";

/**
 * Une page de la table « SMS » du tableau de bord. Miroir exact de
 * `getOverviewCalls` : `getOverviewStats` ne porte que les 100 SMS les plus
 * récents de la période, la table s'arrêtait donc à dix pages de dix. Cette
 * route sert les pages suivantes, avec la même mise en forme de ligne
 * (`buildLastSms` côté serveur). Le total affiché reste celui de `smsStats`,
 * déjà calculé sur toute la période.
 */
async function getOverviewSms(
    auth: Authentication | null,
    page: number,
    pageSize: number,
    period?: [Dayjs | null, Dayjs | null],
    subscriptionIds?: string[],
    exclude?: string[],
): Promise<LastSmsEntry[]> {
    if (!auth) return [];

    const body: {
        period?: { from: number; to: number };
        subscriptionIds?: string[];
        exclude?: string[];
        page: number;
        pageSize: number;
    } = { page, pageSize };

    if (period && period[0] && period[1]) {
        body.period = {
            from: period[0].startOf('day').toDate().getTime(),
            to: period[1].endOf('day').toDate().getTime(),
        };
    }
    if (subscriptionIds && subscriptionIds.length > 0) {
        body.subscriptionIds = subscriptionIds;
    }
    if (exclude && exclude.length > 0) {
        body.exclude = exclude;
    }

    const response = await HttpClient.post('/leedflow/overview-sms', body, auth.token);
    return (response?.rows ?? []) as LastSmsEntry[];
}

export default getOverviewSms;
